module.exports = __webpack_public_path__ + "static/housebuilding_1920-30f5650bf2e96de8ff4fafc968eb8887.jpg";